import { Icon } from '@bridebook/aura';
import { Mobile, Desktop } from '@bridebook/aura/src/icons';
import { TabsRounded } from '@bridebook/ui';
import { DesktopPreviewDevice } from '@bridebook/web/lib/wedding-website/desktop/types';

type Props = {
  activePreviewDevice: DesktopPreviewDevice;
  setActivePreviewDevice: (device: DesktopPreviewDevice) => void;
};

export const MobileDesktopToggle = ({ activePreviewDevice, setActivePreviewDevice }: Props) => (
  <TabsRounded
    tabs={[
      {
        title: <Icon icon={Mobile} size={16} />,
        id: DesktopPreviewDevice.Mobile,
      },
      {
        title: <Icon icon={Desktop} size={16} />,
        id: DesktopPreviewDevice.Desktop,
      },
    ]}
    activeTabId={activePreviewDevice}
    onClick={setActivePreviewDevice}
    size="small"
    tabPadding={2}
  />
);
